import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F24769F6-25C3-4244-8C64-13A514E7CAAD
 * name apple-keyboard-control
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/apple-keyboard-control.svg
 * tags
 */
export const AppleKeyboardControlIcon = createSvgIcon(<><path d="M19.78,11.78L18.36,13.19L12,6.83L5.64,13.19L4.22,11.78L12,4L19.78,11.78Z" /></>, 'AppleKeyboardControlIcon');
export default AppleKeyboardControlIcon